/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDeleteOfferFromFavoritesModel,
  IDeleteOfferFromFavoritesRequest,
  IMappers,
  IDeleteOfferFromFavoritesResponse,
  IDeleteOfferFromFavoritesResponseError,
  TDeleteOfferFromFavoritesResponse,
} from './types';

const defaultConfig: TDeleteOfferFromFavoritesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/delete-offer-from-favorites/',
  hostType: 'api',
} as TDeleteOfferFromFavoritesModel;

function createDeleteOfferFromFavoritesModel(
  parameters: IDeleteOfferFromFavoritesRequest,
): TDeleteOfferFromFavoritesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IDeleteOfferFromFavoritesRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchDeleteOfferFromFavorites<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TDeleteOfferFromFavoritesResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDeleteOfferFromFavoritesModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteOfferFromFavoritesResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IDeleteOfferFromFavoritesResponseError);
    }
  }

  return { response, statusCode } as TDeleteOfferFromFavoritesResponse;
}

export { defaultConfig, createDeleteOfferFromFavoritesModel, fetchDeleteOfferFromFavorites };
